import { render, staticRenderFns } from "./ProfileCart.vue?vue&type=template&id=0287958e"
import script from "./ProfileCart.vue?vue&type=script&lang=js"
export * from "./ProfileCart.vue?vue&type=script&lang=js"
import style0 from "./ProfileCart.vue?vue&type=style&index=0&id=0287958e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports